import React from "react";

import { Paper } from "@/components/paper/Paper";

import { ModalCloseCross } from "../components/ModalCloseCross";

type PropTypes = {
  onClose: () => void;
};
export const CreateOneTimePurchaseCoinsModal: React.FC<PropTypes> = ({
  onClose,
}) => {
  return (
    <Paper className=" w-80 h-80 max-w-full relative ">
      <ModalCloseCross absolute onClose={onClose} />
      One Time PurchaseModal here
    </Paper>
  );
};
